import React from 'react';
import classNames from 'classnames';
import { getFormatNumber } from '../../../../../../../shared/utils';
import { accessibleOnClick } from '../../../../../../../shared/utils/accessible-on-click';
import { getSavedViewDefaultClassNames } from '../utils/helper';

interface IAllProspectChipProps {
  selectedSavedViewId: number;
  isCountLoading: boolean;
  onRemoveFilter: VoidFunction;
  prospectCount: number;
  label: string;
}

const AllProspectChip: React.FC<IAllProspectChipProps> = ({
  selectedSavedViewId,
  isCountLoading,
  onRemoveFilter,
  prospectCount,
  label = '',
}) => {
  const chipClassNames = classNames([
    getSavedViewDefaultClassNames(),
    {
      'saved-filters__item-active': !selectedSavedViewId,
    },
  ]);

  return (
    <div
      className={chipClassNames}
      {...accessibleOnClick(() => {
        if (selectedSavedViewId) {
          onRemoveFilter();
        }
      })}
    >
      {label}
      {!isCountLoading && !selectedSavedViewId && (
        <div className="d-flex align-items-center gap-4 ml-1">
          <div className="saved-filters__item-count regular-1 font-medium line-height-16 blue-txt-17">
            {getFormatNumber(prospectCount)}
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(AllProspectChip);
